import clsx from 'clsx';
import { Button } from 'react-bootstrap';
import {
  SOCIAL_MEDIA_CONTENT_TYPE_CAROUSEL,
  SOCIAL_MEDIA_CONTENT_TYPE_REEL,
  SocialMediaContentType,
} from '../../types';

const SocialMediaPostType = (props: {
  displayName: string;
  type: SocialMediaContentType;
  isSelected: boolean;
  onSelected: (type: SocialMediaContentType) => void;
}) => {
  const { displayName, type, isSelected, onSelected } = props;
  return (
    <Button
      type="button"
      className={clsx('multilevel-tab-panel__top-level-tab', {
        'multilevel-tab-panel__top-level-tab--selected': isSelected,
      })}
      onClick={() => onSelected(type)}
    >
      {displayName}
    </Button>
  );
};

export const ProgramEditSocialMediaContentType = (props: {
  selectedType: SocialMediaContentType;
  onSelected: (type: SocialMediaContentType) => void;
}) => {
  const { selectedType, onSelected } = props;
  return (
    <div className="program-edit__social-posting-content-type-containers">
      <SocialMediaPostType
        displayName="Carousel"
        type={SOCIAL_MEDIA_CONTENT_TYPE_CAROUSEL}
        isSelected={selectedType === SOCIAL_MEDIA_CONTENT_TYPE_CAROUSEL}
        onSelected={onSelected}
      />
      <SocialMediaPostType
        displayName="Reel"
        type={SOCIAL_MEDIA_CONTENT_TYPE_REEL}
        isSelected={selectedType === SOCIAL_MEDIA_CONTENT_TYPE_REEL}
        onSelected={onSelected}
      />
    </div>
  );
};
